import { render, staticRenderFns } from "./Pessoa.vue?vue&type=template&id=533ed4d8&scoped=true&"
import script from "./Pessoa.vue?vue&type=script&lang=js&"
export * from "./Pessoa.vue?vue&type=script&lang=js&"
import style0 from "./Pessoa.vue?vue&type=style&index=0&id=533ed4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ed4d8",
  null
  
)

export default component.exports